// extracted by mini-css-extract-plugin
export default {"container":"vQWKDNtuIIS0ejtklkk15","heading":"_2cnWnfXqtNpnpdS9hbAtGb"};